/**
 * PaletteRows — metrics + subformulas + custom number inserter
 * For Media Devoted | Created By Ciro Autiero
 */

import { FC, useState } from 'react';
import type { FlowOptimizerMetricMeta, FormulaSubformula } from '@trafficpulse/shared';

import { Button } from '@/components/ui/layout/Button';

import PaletteChip from './PaletteChip';

export const MetricsRow: FC<{
  metrics: FlowOptimizerMetricMeta[];
  onPick: (id: string) => void;
}> = ({ metrics, onPick }) => {
  if (metrics.length === 0) {
    return <span className="text-xs italic text-muted-foreground">No metrics available.</span>;
  }
  return (
    <>
      {metrics.map((m) => (
        <PaletteChip key={m.id} tone="metric" onClick={() => onPick(m.id)}>
          {m.name}
        </PaletteChip>
      ))}
    </>
  );
};

export const SubformulasRow: FC<{
  subformulas: FormulaSubformula[];
  onPick: (subId: string) => void;
}> = ({ subformulas, onPick }) => (
  <>
    {subformulas.map((s) => (
      <PaletteChip key={s.id} tone="subref" onClick={() => onPick(s.id)}>
        {s.name || 'Subformula'}
      </PaletteChip>
    ))}
  </>
);

export const NumberInsertControls: FC<{ onInsert: (value: string) => void }> = ({ onInsert }) => {
  const [text, setText] = useState('');
  const submit = () => {
    const value = Number(text);
    if (!Number.isFinite(value) || text.trim() === '') return;
    onInsert(String(value));
    setText('');
  };
  return (
    <span className="inline-flex items-center gap-1">
      <input
        type="number"
        value={text}
        onChange={(e) => setText(e.target.value)}
        onKeyDown={(e) => {
          if (e.key !== 'Enter') return;
          e.preventDefault();
          submit();
        }}
        placeholder="custom"
        className="h-7 w-20 rounded-md border border-input bg-background px-2 text-xs"
      />
      <Button size="sm" variant="outline" type="button" onClick={submit} className="h-7 px-2 text-xs">
        Insert
      </Button>
    </span>
  );
};
